import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { CHART_COLORS, chartTooltipStyle, tickFormatter } from '@/features/reports/lib/chartTheme';
import { formatNumber, formatPercent, formatToman } from '@/features/reports/lib/format';

/**
 * Horizontal ranking bars — best sellers, category rollups, vendor leaderboards.
 *
 * Category labels sit on the right and bars grow leftwards, matching the RTL
 * reading order of the rest of the panel.
 */
export default function RankBarChart({
    rows = [],
    labelKey = 'label',
    valueKey = 'revenue',
    money = true,
    height = 360,
    yAxisWidth = 130,
    colorByIndex = true,
    showShare = true,
}) {
    const format = money ? formatToman : formatNumber;

    const tooltip = ({ active, payload }) => {
        if (!active || !payload?.length) return null;
        const row = payload[0].payload;
        return (
            <div className="report-tooltip">
                <p className="report-tooltip-title">{row[labelKey]}</p>
                <p className="report-tooltip-row">
                    <span>{money ? 'درآمد' : 'تعداد'}</span>
                    <strong>{format(row[valueKey])}</strong>
                </p>
                {showShare && row.revenue_share_pct !== undefined && (
                    <p className="report-tooltip-row report-tooltip-muted">
                        <span>سهم از کل</span>
                        <span>{formatPercent(row.revenue_share_pct)}</span>
                    </p>
                )}
            </div>
        );
    };

    return (
        <div style={{ width: '100%', height }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={rows}
                    layout="vertical"
                    margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
                >
                    <XAxis
                        type="number"
                        reversed
                        tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={tickFormatter}
                    />
                    <YAxis
                        type="category"
                        dataKey={labelKey}
                        orientation="right"
                        width={yAxisWidth}
                        tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
                        tickLine={false}
                        axisLine={false}
                    />
                    <Tooltip content={tooltip} contentStyle={chartTooltipStyle} cursor={{ fill: 'rgba(46,125,50,0.06)' }} />
                    <Bar dataKey={valueKey} radius={[0, 6, 6, 0]} name={money ? 'درآمد' : 'تعداد'} barSize={16}>
                        {rows.map((row, index) => (
                            <Cell
                                key={row.key ?? row.category_id ?? row.product_id ?? index}
                                fill={colorByIndex ? CHART_COLORS[index % CHART_COLORS.length] : '#2E7D32'}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
